import get from 'lodash/get'

/**
 * Takes a value and replaces it (if available in replacements)
 * @param {string} value
 * @param {object} replacements
 * @return {*}
 */
export function replaceVariable (value, replacements) {
  if (!value) {
    return value
  }
  const lookup = value.substring(1)
  const v = get(replacements, lookup)
  return v ?? value
}

/**
 * Takes an object used for configuration and substitutes tokens with values based upon what is available in appContext
 * @param {object} obj
 * @param {object} replacements
 * @return {{[p: string]: any}}
 */
export function replaceObjectValues (obj, replacements) {
  if (!obj) return obj

  const entries = Object.entries(obj).map(([key, value]) => [
    key,
    replaceValues(value, replacements)
  ])
  return Object.fromEntries(entries)
}

/**
 * Replaces the values of an array
 * @param {Array<*>} array
 * @param {object} replacements
 * @return {Array<*>}
 */
export function replaceArrayValues (array, replacements) {
  if (!array) return array

  return array.map(value => replaceValues(value, replacements))
}

/**
 * Replaces placeholders in a string like ${{ key }}
 */
export function replacePlaceholders (str, replacements) {
  return str.replace(/\$\{\{\s*(\w+)\s*\}\}/g, (match, key) =>
    key in replacements ? replacements[key] : ''
  )
}

export function replaceValues (value, replacements) {
  if (value == null) return value

  if (typeof value === 'string' && value.startsWith('$')) {
    return replaceVariable(value, replacements)
  }
  if (Array.isArray(value)) {
    return replaceArrayValues(value, replacements)
  }
  if (typeof value === 'object') {
    return replaceObjectValues(value, replacements)
  }
  return value
}

/**
 * Returns [output, missingTokens]
 * where missingTokens is an array of lookups that weren’t found
 */
export function replaceValuesEx (value, replacements) {
  const missing = []

  function helper (val) {
    if (val == null) return val

    if (typeof val === 'string' && val.startsWith('$')) {
      const lookup = val.substring(1)
      const v = get(replacements, lookup)
      if (v === undefined) {
        missing.push(lookup)
        return val
      }
      return v
    }

    if (Array.isArray(val)) {
      return val.map(item => helper(item))
    }

    if (typeof val === 'object') {
      return Object.fromEntries(
        Object.entries(val).map(([k, v]) => [k, helper(v)])
      )
    }

    return val
  }

  const output = helper(value)
  return [output, missing]
}
